// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--YcADC","title":"a10a3f92e9--title--3txHf","text":"a10a3f92e9--text--2SSPg"};